import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
// import ReviewSummaryResult from '../../../../widgets/reviewSummary/ReviewSummaryResult'
import ReviewSummaryResultSubProject from '../../../../widgets/reviewSummary/ReviewSummaryResultSubProject'
import { getSchemaReviewSummary } from '../../../../redux/actions/reviewSummary'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'

const mockData = {
  message: 'Successfully',
  success: true,
  model: {
    header: 'ขั้นที่ 2 ผลการพิจารณากลั่นกรอง และสรุปผล',
    subHeader: 'ข้อเสนอโครงการย่อย ',
    forms: {
      projectInfo: {
        projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
        mainProject: {
          header: 'โครงการหลัก',
          projectId: null,
          versionCode: null,
          projectNameTitle: 'ชื่อโครงการ',
          projectName: 'เด็กฉลาด ขอทำข้อตกลงเพิ่มเติม 1',
          projectCodeTitle: 'รหัสโครงการ',
          projectCode: 'R06-0220',
          projectTypeTitle: 'ประเภทโครงการ',
          projectType: 'โครงการวิจัยและประเมินผล',
          ownerNameTitle: 'ผู้ยื่นข้อเสนอ',
          ownerName: 'คุณ วัลลภ บุญประเสริฐ',
          activityTypeTitle: 'ลักษณะกิจกรรม',
          activityTypeTitle2: '(ประเภทโครงการ)',
          activityType: 'โครงการวิจัยและประเมินผล',
        },
        subProject: {
          header: 'โครงการย่อย',
          projectId: null,
          versionCode: null,
          projectNameTitle: 'ชื่อโครงการ',
          projectName: 'เด็กฉลาด ขอทำข้อตกลงเพิ่มเติม ย่อย',
          projectCodeTitle: 'รหัสโครงการ',
          projectCode: 'R06-0220-A',
          projectTypeTitle: 'ประเภทโครงการ',
          projectType: 'โครงการวิจัยและประเมินผล',
          ownerNameTitle: 'ชื่อผู้เสนอ',
          ownerName: 'คุณ ทอม แบรนเนอร์',
          activityTypeTitle: 'ลักษณะกิจกรรม',
          activityTypeTitle2: '(ประเภทโครงการ)',
          activityType: 'โครงการวิจัยและประเมินผล',
        },
      },
      ReviewerApproveList: { header: 'รายชื่อผู้ทรงคุณวุฒิที่ผ่านการพิจารณาแล้ว', itemsList: [] },
      ReviewerSummary: {
        header: 'สรุปผลการพิจารณากลั่นกรอง',
        projectVersionId: 'undefined',
        projectReviewId: '',
        // background: {
        //   id: '2-1001-001',
        //   projectFeedbackId: '',
        //   name: 'background',
        //   label: 'ความเป็นมา หลักการและเหตุผล มีความชัดเจนหรือไม่ อย่างไร',
        //   placeholder: 'ความเป็นมา หลักการและเหตุผล มีความชัดเจนหรือไม่ อย่างไร',
        //   value: '',
        //   comment: [],
        //   validators: [
        //     { type: 'REQUIRED', errorMessage: 'กรุณากรอกสรุปความเป็นมา หลักการและเหตุผล' },
        //   ],
        // },
        // objective: {
        //   id: '2-1001-002',
        //   projectFeedbackId: '',
        //   name: 'objective',
        //   label:
        //     'เป้าประสงค์ วัตถุประสงค์ ตัวชี้วัดมีความเหมาะสมและสอดคล้องกับหลักการและเหตุผลหรือไม่ อย่างไร',
        //   placeholder:
        //     'เป้าประสงค์ วัตถุประสงค์ ตัวชี้วัดมีความเหมาะสมและสอดคล้องกับหลักการและเหตุผลหรือไม่ อย่างไร',
        //   value: '',
        //   comment: [],
        //   validators: [
        //     { type: 'REQUIRED', errorMessage: 'กรุณากรอกสรุปเป้าประสงค์ วัตถุประสงค์ ตัวชี้วัด' },
        //   ],
        // },
        // periodAndPlan: {
        //   id: '2-1001-003',
        //   projectFeedbackId: '',
        //   name: 'periodAndPlan',
        //   label: 'ระยะเวลาโครงการและแผนการดำเนินงานมีรายละเอียดที่ชัดเจนหรือไม่ อย่างไร',
        //   placeholder: 'ระยะเวลาโครงการและแผนการดำเนินงานมีรายละเอียดที่ชัดเจนหรือไม่ อย่างไร',
        //   value: '',
        //   comment: [],
        //   validators: [
        //     { type: 'REQUIRED', errorMessage: 'กรุณากรอกสรุประยะเวลาโครงการและแผนการดำเนินงาน' },
        //   ],
        // },
        // targetGroup: {
        //   id: '2-1001-004',
        //   projectFeedbackId: '',
        //   name: 'targetGroup',
        //   label: 'กลุ่มเป้าหมายและพื้นที่ดำเนินการมีความเหมาะสมหรือไม่ อย่างไร',
        //   placeholder: 'กลุ่มเป้าหมายและพื้นที่ดำเนินการมีความเหมาะสมหรือไม่ อย่างไร',
        //   value: '',
        //   comment: [],
        //   validators: [
        //     { type: 'REQUIRED', errorMessage: 'กรุณากรอกสรุปกลุ่มเป้าหมายและพื้นที่ดำเนินการ' },
        //   ],
        // },
        // budget: {
        //   id: '2-1001-005',
        //   projectFeedbackId: '',
        //   name: 'budget',
        //   label: 'งบประมาณมีรายละเอียดที่เหมาะสมหรือไม่ หากเทียบกับเป้าประสงค์และขอบเขตของโครงการ',
        //   placeholder:
        //     'งบประมาณมีรายละเอียดที่เหมาะสมหรือไม่ หากเทียบกับเป้าประสงค์และขอบเขตของโครงการ',
        //   value: '',
        //   comment: [],
        //   validators: [{ type: 'REQUIRED', errorMessage: 'กรุณากรอกสรุปงบประมาณมีรายละเอียด' }],
        // },
        // monitoring: {
        //   id: '2-1001-006',
        //   projectFeedbackId: '',
        //   name: 'monitoring',
        //   label: 'การกำกับติดตามและประเมินผลมีรายละเอียดที่ชัดเจนหรือไม่ อย่างไร',
        //   placeholder: 'การกำกับติดตามและประเมินผลมีรายละเอียดที่ชัดเจนหรือไม่ อย่างไร',
        //   value: '',
        //   comment: [],
        //   validators: [
        //     { type: 'REQUIRED', errorMessage: 'กรุณากรอกสรุปการกำกับติดตามและประเมินผล' },
        //   ],
        // },
        // expectedResult: {
        //   id: '2-1001-007',
        //   projectFeedbackId: '',
        //   name: 'expectedResult',
        //   label:
        //     'ผลที่คาดว่าจะได้รับและการขยายผลมีรายละเอียดของผลลัพธ์หรือผลกระทบที่ชัดเจนหรือไม่ อย่างไร',
        //   placeholder:
        //     'ผลที่คาดว่าจะได้รับและการขยายผลมีรายละเอียดของผลลัพธ์หรือผลกระทบที่ชัดเจนหรือไม่ อย่างไร',
        //   value: '',
        //   comment: [],
        //   validators: [
        //     { type: 'REQUIRED', errorMessage: 'กรุณากรอกสรุปผลที่คาดว่าจะได้รับและการขยายผล' },
        //   ],
        // },
        // otherComment: {
        //   id: '2-1001-008',
        //   projectFeedbackId: '',
        //   name: 'otherComment',
        //   label: 'ความเห็นและข้อเสนอแนะเพิ่มเติมอื่นๆ',
        //   placeholder: 'ความเห็นและข้อเสนอแนะเพิ่มเติมอื่นๆ',
        //   value: '',
        //   comment: [],
        //   validators: [{ type: 'REQUIRED', errorMessage: 'กรุณากรอกสรุปความเห็นและข้อเสนอแนะ' }],
        // },
        // summaryResult: {
        //   id: '2-1002-001',
        //   projectFeedbackId: '',
        //   name: 'summaryResult',
        //   label: 'ความเห็นและข้อเสนอแนะเพิ่มเติมอื่นๆ',
        //   placeholder: 'ความเห็นและข้อเสนอแนะเพิ่มเติมอื่นๆ',
        //   value: '',
        //   comment: [],
        //   validators: [{ type: 'REQUIRED', errorMessage: 'กรุณากรอกสรุปความเห็นการกลั่นกรอง' }],
        // },
        reviewResult: {
          id: '2-1004-001',
          name: 'reviewResult',
          label: 'สรุปผลการพิจารณากลั่นกรอง',
          placeholder: 'สรุปผลการพิจารณากลั่นกรอง',
          value: '',
          validators: [{ type: 'REQUIRED', errorMessage: 'กรุณากรอกสรุปผลการกลั่นกรอง' }],
        },
        typeOfScrutinize: {
          options: [
            { disabled: false, label: 'ให้คะแนน', value: '0' },
            { disabled: false, label: 'แบบประชุม', value: '1' },
          ],
          name: 'contractsignType',
          label: 'วิธีการกลั่นกรอง',
          value: '',
          validators: [
            { type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือก วิธีการกลั่นกรอง' },
          ],
        },
        reviewerFilter: {
          id: '2-1004-002',
          name: 'reviewerFilter',
          value: '3',
          options: [
            { label: 'ไม่ผ่านการกลั่นกรอง', value: 0 },
            { label: 'ผ่านการกลั่นกรอง (มีการแก้ไข)', value: 1 },
            { label: 'ผ่านการกลั่นกรอง', value: 3 },
          ],
          validators: [{ type: 'REQUIRED', errorMessage: 'กรุณาเลือก' }],
        },
        dateOfScrutinize: {
          name: 'dateOfBirth',
          label: 'วันที่กลั่นกรอง',
          value: '',
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุวันที่กลั่นกรอง' }],
        },
        dateOfScrutinizeRes: {
          name: 'dateOfBirth',
          label: 'วันที่บันทึกผลการกลั่นกรอง',
          value: '',
          validators: [
            { type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุวันที่บันทึกผลการกลั่นกรอง' },
          ],
        },
        reviewType: 1,
      },
    },
  },
}

export default function ReviewSummarySub() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // const _schema = await getSchemaReviewSummary(projectId)

      setSchema(mockData.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isSubProject>
      <ContentHeader header={schema.header + 'โครงการย่อย'} subHeader={schema.subHeader} />

      {/* <ReviewSummaryResult schema={schema.forms} /> */}
      <ReviewSummaryResultSubProject schema={schema.forms} />
      <br />
    </SidebarProposal>
  )
}
